import { connectRouter } from "connected-react-router";
import layoutContext from "./AdminLayoutRedux";
import common from "./CommonRedux";
import layout from "./LayoutRedux";
import user from "./UserRedux";
import { reducer as farm } from "./FarmRedux";
import { reducer as listing } from "./ListingRedux";
import { reducer as estimate } from "./EstimateRedux";
import { reducer as estimateOverview } from "./EstimateOverviewRedux";
import { reducer as bidDetails } from "./BidDetailsRedux";
import { reducer as audit } from "./AuditRedux";
import { reducer as auth } from "./AuthRedux";
import { reducer as tenant } from "./TenantRedux";


export default (history) => ({
  router: connectRouter(history),
  farm,
  estimate,
  estimateOverview,
  bidDetails,
  listing,
  user,
  audit,
  auth,
  tenant,
  layout,
  layoutContext,
  common,
});
